import { LinkButton } from "~/common/components/Link";
import { IconType } from "~/common/components/icon/IconType";
import { useTranslation } from "react-i18next";
import { type MouseEventHandler } from "react";
import { Button } from "~/common/components/Button/Button";
import { DefaultButtonIcon } from "~/common/components/icon/Icon";

interface Props {
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}
export const ResetAllBtn = (props: Props) => {
  const { t } = useTranslation();
  return (
    <Button variant={"text"} startIcon={<DefaultButtonIcon type={IconType.Reset} />} {...props}>
      {t("page.selectionAssistant.resetAllFilters")}
    </Button>
  );
};

export const ResetAllLinkBtn = (props: Props) => {
  const { t } = useTranslation();
  return (
    <LinkButton iconBefore={<DefaultButtonIcon type={IconType.Reset} />} {...props}>
      {t("page.selectionAssistant.resetAllFilters")}
    </LinkButton>
  );
};
